import '../sass/featured-work.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const swiperScript = document.querySelector('#boomspace-theme-swiper-js');
    const $blocks = document.querySelectorAll('.featured-work');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $slider = $block.querySelector('.featured-work__carousel');
        const $navigationPrevious = $block.querySelector('.featured-work__navigation-button--previous');
        const $navigationNext = $block.querySelector('.featured-work__navigation-button--next');

        const initCarousel = () => {
            if (!$slider) return;

            new Swiper($slider, {
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                spaceBetween: 20,
                breakpoints: {
                    768: {
                        spaceBetween: 40
                    }
                },
                navigation: {
                    prevEl: $navigationPrevious,
                    nextEl: $navigationNext
                },
                pagination: {
                    el: '.featured-work__pagination',
                    clickable: true
                },
                speed: noMotionPreference.matches ? 300 : 0,
                slidesPerView: 'auto',
            });
        };

        if (typeof Swiper !== 'undefined') { 
            initCarousel();
        } else {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        }
    });
})();
